import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CheckBoxOptions, DropdownOptions, EnglishArabicDTO, FilterItem, FilterType, ForceDirection, InputType, MultiLingualTextBoxOptions, PagingOptions, TextAreaOptions, TextBoxOptions } from 'bnsights-control-library';
import { DataSecretService } from '../../shared/Services/data.service';
import { PublicHolidayService } from '../../shared/Services/PublicHolidayService.service';
import { PublicHolidayModel } from '../../shared/models/PublicHolidayModels/PublicHolidayModel';
import { UsersIDRequestModel } from '../../shared/models/UserModels/UsersIDRequestModel';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-public-holiday',
  templateUrl: './public-holiday.component.html'
})
export class PublicHolidayComponent implements OnInit {
  ApiUrl = "/api/admin/PublicHoliday/"
  searchTextBox: TextBoxOptions;
  CountriesList = [];
  MonthsList = [];
  DaysList = [];
  PublicHolidayForm = new FormGroup({});
  showFilter: boolean = false;
  PublicHolidayPagingResult: any[] = [];
  PublicHolidayPaging: PagingOptions;
  TextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean = false;
  @ViewChild('PublicHolidayPagingViewElement', { static: false }) input: ElementRef;


  //Add Model Controls
  AddPublicHolidayForm = new FormGroup({});
  MultiLingualName:MultiLingualTextBoxOptions
  DescriptionInEnglish: TextAreaOptions;
  DescriptionInArabic: TextAreaOptions;
  CountryOptions: DropdownOptions;
  MonthOptions: DropdownOptions;
  DayOptions: DropdownOptions;
  SysName: TextBoxOptions;
  IsActive: CheckBoxOptions;
  @ViewChild('ClosePublicHolidayModal', { static: false }) ClosePublicHolidayModal: ElementRef;

  //Edit Model Controls
  EditPublicHolidayForm = new FormGroup({});
  EditMultiLingualName:MultiLingualTextBoxOptions
  EditDescriptionInEnglish: TextAreaOptions;
  EditDescriptionInArabic: TextAreaOptions;
  EditCountryOptions: DropdownOptions;
  EditMonthOptions: DropdownOptions;
  EditDayOptions: DropdownOptions;
  EditSysName: TextBoxOptions;
  EditIsActive: CheckBoxOptions;
  IsEditPublicHolidayModelLoaded: boolean;
  PublicHolidayId: number;
  @ViewChild('CloseEditPublicHolidayModal', { static: false }) CloseEditPublicHolidayModal: ElementRef;

  //delete  Model Controls
  deletePublicHolidayList: any[] = []
  @ViewChild('CloseDeletePublicHolidayModal', { static: false }) CloseDeletePublicHolidayModal: ElementRef;

  //generate UAE public holidays
  @ViewChild('CloseGeneratePublicHolidayModal', { static: false }) CloseGeneratePublicHolidayModal: ElementRef;


  language: string = ""
  // Decorator wires up blockUI instance

  ShowPageContent:boolean=false

  constructor(private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,private dataServices: DataSecretService, private authService: AuthService, private PublicHolidayService: PublicHolidayService, private modalService: NgbModal) {
  }
  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    PageInfoService.PageTitle=this.utilityService.getResourceValue("PublicHolidays")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.ShowPageContent=false;
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language =  await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.LoadList();
  }


  //initialize filters and load any drop down list
  LoadList() {
    this.PublicHolidayService.Loaddropdowns().subscribe((result) => {
      let DropdownLists = result as any
      this.CountriesList = DropdownLists.countries;
      this.MonthsList = DropdownLists.months;
      this.DaysList = DropdownLists.days;
       // TextBox inti
      this.searchTextBox = new TextBoxOptions();
      this.searchTextBox.Name = "searchTextBox"
      this.searchTextBox.Type = InputType.Text
      this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")
      this.searchTextBox.HideLabel = true

      this.TextInputFilter = new FilterItem();
      this.TextInputFilter.FormControlName = "searchTextBox"
      this.TextInputFilter.ActionParameterName = "searchText"
      this.TextInputFilter.IsFormControl = true
      this.TextInputFilter.FilterType = FilterType.TextBox

      this.PublicHolidayPaging = new PagingOptions();
      this.PublicHolidayPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetPublicHolidaysByFilter';
      this.PublicHolidayPaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
      this.PublicHolidayPaging.Filters = [this.TextInputFilter]
      this.PublicHolidayPaging.ValidationToken = this.authService.authorizationHeaderValue()
      this.IsFilterLoaded = true;
  
    })
  }



  ReinitializePublicHolidayPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdatePublicHolidayPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setPublicHolidayListResult(result) {
    this.PublicHolidayPagingResult = result;
    this.ShowPageContent=true;
    this.utilityService.stopBlockUI();
  }

  resetFilters() {
    this.PublicHolidayForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }


  showAddPublicHolidayModal(AddPublicHolidayModal) {
    this.utilityService.startBlockUI();
    this.AddPublicHolidayForm = new FormGroup({})

    this.MultiLingualName = new MultiLingualTextBoxOptions();
    this.MultiLingualName.Name = "Name";
    this.MultiLingualName.ArabicLabelKey = "NameInArabic";
    this.MultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.MultiLingualName.IsRequired = true;
    this.MultiLingualName.Value = null;

    this.SysName = new TextBoxOptions();
    this.SysName.Name = "SysName";
    this.SysName.LabelKey = "SysName";
    this.SysName.Type = InputType.Text;
    this.SysName.Value = null;
    this.SysName.IsRequired = true;

    this.DescriptionInEnglish = new TextAreaOptions();
    this.DescriptionInEnglish.Name = "DescriptionInEnglish";
    this.DescriptionInEnglish.LabelKey = "DescriptionInEnglish";
    this.DescriptionInEnglish.Value = null;
    this.DescriptionInEnglish.IsRequired = true;

    this.DescriptionInArabic = new TextAreaOptions();
    this.DescriptionInArabic.Name = "DescriptionInArabic";
    this.DescriptionInArabic.LabelKey = "DescriptionInArabic";
    this.DescriptionInArabic.Value = null;
    this.DescriptionInArabic.IsRequired = true;
    this.DescriptionInArabic.ForceDirection = ForceDirection.Arabic;

    this.CountryOptions = new DropdownOptions();
    this.CountryOptions.Name = "CountryOptions"
    this.CountryOptions.LabelKey = "Country"
    this.CountryOptions.DataSource = this.CountriesList
    this.CountryOptions.SingleSelection = true;
    this.CountryOptions.AllowSearchFilter = true;
    this.CountryOptions.Placeholder = "";
    this.CountryOptions.IsRequired = true;

      //Months init
   this.MonthOptions = new DropdownOptions();
   this.MonthOptions.Name = "MonthOptions"
   this.MonthOptions.LabelKey = "Month"
   this.MonthOptions.DataSource = this.MonthsList
   this.MonthOptions.SingleSelection = true;
   this.MonthOptions.AllowSearchFilter = true;
   this.MonthOptions.Placeholder = "";
   this.MonthOptions.IsRequired = true;

   //Days init
   this.DayOptions = new DropdownOptions();
   this.DayOptions.Name = "DayOptions"
   this.DayOptions.LabelKey = "Day"
   this.DayOptions.DataSource = this.DaysList
   this.DayOptions.SingleSelection = true;
   this.DayOptions.AllowSearchFilter = true;
   this.DayOptions.Placeholder = "";
   this.DayOptions.IsRequired = true;

    this.IsActive = new CheckBoxOptions();
    this.IsActive.Name = "IsActive"
   this.IsActive.LabelKey = "Active"
   this.IsActive.Value = false
    this.modalService.open(AddPublicHolidayModal);
    this.utilityService.stopBlockUI();
  }
  addPublicHoliday() {
    if (this.AddPublicHolidayForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddPublicHolidayForm.value;
      let AddModel:PublicHolidayModel= new PublicHolidayModel();
      AddModel.SysName = ResultModel.SysName;
      AddModel.Name.Arabic = ResultModel.Name.ArabicValue;
      AddModel.Name.English = ResultModel.Name.EnglishValue;
      AddModel.Description.Arabic = ResultModel.DescriptionInArabic;
      AddModel.Description.English = ResultModel.DescriptionInEnglish;
      AddModel.CountryID = ResultModel.CountryOptions!=null?Number(ResultModel.CountryOptions):null;
      AddModel.IsActive = ResultModel.IsActive;
      AddModel.Day = ResultModel.DayOptions != null ? Number(ResultModel.DayOptions) : 0;
      AddModel.Month = ResultModel.MonthOptions != null ? Number(ResultModel.MonthOptions) : 0;


      this.PublicHolidayService.AddPublicHoliday(AddModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
      })
    }
  }


  showEditPublicHolidayModal(PublicHoliday: any, EditPublicHolidayModal) {
    this.utilityService.startBlockUI();

    this.EditPublicHolidayForm = new FormGroup({})
    this.PublicHolidayId = PublicHoliday.id

    let Name=new EnglishArabicDTO();
    Name.Arabic=PublicHoliday.name.arabic;
    Name.English=PublicHoliday.name.english;

    this.EditMultiLingualName = new MultiLingualTextBoxOptions();
    this.EditMultiLingualName.Name = "Name";
    this.EditMultiLingualName.ArabicLabelKey = "NameInArabic";
    this.EditMultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.EditMultiLingualName.IsRequired = true;
    this.EditMultiLingualName.Value = Name;

    this.EditSysName = new TextBoxOptions();
    this.EditSysName.Name = "EditSysName";
    this.EditSysName.LabelKey = "SysName";
    this.EditSysName.Type = InputType.Text;
    this.EditSysName.Value = PublicHoliday.sysName;
    this.EditSysName.IsRequired = true;

    this.EditDescriptionInEnglish = new TextAreaOptions();
    this.EditDescriptionInEnglish.Name = "EditDescriptionInEnglish";
    this.EditDescriptionInEnglish.LabelKey = "DescriptionInEnglish";
    this.EditDescriptionInEnglish.Value = PublicHoliday.description.english;
    this.EditDescriptionInEnglish.IsRequired = false;

    this.EditDescriptionInArabic = new TextAreaOptions();
    this.EditDescriptionInArabic.Name = "EditDescriptionInArabic";
    this.EditDescriptionInArabic.LabelKey = "DescriptionInArabic";
    this.EditDescriptionInArabic.Value = PublicHoliday.description.arabic;
    this.EditDescriptionInArabic.ForceDirection = ForceDirection.Arabic;

    this.EditCountryOptions = new DropdownOptions();
    this.EditCountryOptions.Name = "EditCountryOptions"
    this.EditCountryOptions.LabelKey = "Country"
    this.EditCountryOptions.DataSource = this.CountriesList
    this.EditCountryOptions.SingleSelection = true;
    this.EditCountryOptions.AllowSearchFilter = true;
    this.EditCountryOptions.Placeholder = "";
    this.EditCountryOptions.SelectedItems = this.CountriesList.filter((item) => { return parseInt(item.key) == PublicHoliday.countryID; }).map((item) => item.key)[0];;

    //Months init
    this.EditMonthOptions = new DropdownOptions();
    this.EditMonthOptions.Name = "EditMonthOptions"
    this.EditMonthOptions.LabelKey = "Month"
    this.EditMonthOptions.DataSource = this.MonthsList
    this.EditMonthOptions.SingleSelection = true;
    this.EditMonthOptions.AllowSearchFilter = true;
    this.EditMonthOptions.Placeholder = "";
    this.EditMonthOptions.IsRequired = true;
    this.EditMonthOptions.SelectedItems = this.MonthsList.filter((item) => { return parseInt(item.key) == PublicHoliday.month; }).map((item) => item.key)[0];;

    //Days init
    this.EditDayOptions = new DropdownOptions();
    this.EditDayOptions.Name = "EditDayOptions"
    this.EditDayOptions.LabelKey = "Day"
    this.EditDayOptions.DataSource = this.DaysList
    this.EditDayOptions.SingleSelection = true;
    this.EditDayOptions.AllowSearchFilter = true;
    this.EditDayOptions.Placeholder = "";
    this.EditDayOptions.IsRequired = true;
    this.EditDayOptions.SelectedItems = this.MonthsList.filter((item) => { return parseInt(item.key) == PublicHoliday.day; }).map((item) => item.key)[0];;


    this.EditIsActive = new CheckBoxOptions();
    this.EditIsActive.Name = "EditIsActive"
    this.EditIsActive.LabelKey = "Active"
    this.EditIsActive.Value = PublicHoliday.isActive

    this.modalService.open(EditPublicHolidayModal);
    this.utilityService.stopBlockUI();
   
  }

  editPublicHoliday() {
    if (this.EditPublicHolidayForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditPublicHolidayForm.value;
      let EditModel = new PublicHolidayModel();
      EditModel.ID = Number(this.PublicHolidayId);
      EditModel.Name.Arabic = ResultModel.Name.ArabicValue;
      EditModel.Name.English = ResultModel.Name.EnglishValue;
      EditModel.SysName = ResultModel.EditSysName;
      EditModel.Description.English = ResultModel.EditDescriptionInEnglish
      EditModel.Description.Arabic = ResultModel.EditDescriptionInArabic
      EditModel.IsActive = ResultModel.EditIsActive;
      EditModel.CountryID = ResultModel.EditCountryOptions!=null? Number(ResultModel.EditCountryOptions): null
      EditModel.Day = ResultModel.EditDayOptions != null ? Number(ResultModel.EditDayOptions) : 0;
      EditModel.Month = ResultModel.EditMonthOptions != null ? Number(ResultModel.EditMonthOptions) : 0;

      this.PublicHolidayService.EditPublicHoliday(EditModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {
      })
    }
  }

  showDeletePublicHolidayModal(Resource: any, deletePublicHolidayModal) {
    this.deletePublicHolidayList = []
    this.deletePublicHolidayList.push(Resource);
    this.utilityService.startBlockUI(); 
    this.modalService.open(deletePublicHolidayModal);
    this.utilityService.stopBlockUI();
  }

  deletePublicHoliday() {
    let UsersIDModel: UsersIDRequestModel = new UsersIDRequestModel();
    for (let index = 0; index < this.deletePublicHolidayList.length; index++) {
      const element = this.deletePublicHolidayList[index];
      UsersIDModel.UsersIDs.push(element.id)

    }
    this.PublicHolidayService.DeletePublicHoliday(UsersIDModel).subscribe((result) => {
      this.deletePublicHolidayList = [];
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
    })

  }
  showGenerateUAEPublicHolidayModal(GenerateUAEPublicHolidaysModal) {
    this.modalService.open(GenerateUAEPublicHolidaysModal);
  }
  generateUAEPublicHoliday() {
    this.PublicHolidayService.GenerateUAEPublicHoliday().subscribe((result) => {
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
     
    })
   
  }



}

